import React from 'react'
import { Routes, Route } from 'react-router-dom'
import Layout from './components/Layout'
import HomePage from './pages/HomePage'
import PrivatRengoeringPage from './pages/PrivatRengoeringPage'
import ErhvervsrengoeringPage from './pages/ErhvervsrengoeringPage'
import KlinikRengoeringPage from './pages/KlinikRengoeringPage'
import HovedrengoeringPage from './pages/HovedrengoeringPage'
import FlytterengoeringPage from './pages/FlytterengoeringPage'
import OmOsPage from './pages/OmOsPage'
import KontaktPage from './pages/KontaktPage'
import NotFoundPage from './pages/NotFoundPage'
import ForbiddenPage from './pages/ForbiddenPage'

export default function App() {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route path="/" element={<HomePage />} />
        <Route path="/privat-rengoering" element={<PrivatRengoeringPage />} />
        <Route path="/erhvervsrengoering" element={<ErhvervsrengoeringPage />} />
        <Route path="/klinik-rengoering" element={<KlinikRengoeringPage />} />
        <Route path="/hovedrengoering" element={<HovedrengoeringPage />} />
        <Route path="/flytterengoering" element={<FlytterengoeringPage />} />
        <Route path="/om-os" element={<OmOsPage />} />
        <Route path="/kontakt" element={<KontaktPage />} />
        <Route path="/403" element={<ForbiddenPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Route>
    </Routes>
  )
}
